Date.prototype.yyyymmdd = function () {
  const yyyy = this.getFullYear().toString()
  const mm = (this.getMonth() + 1).toString() // getMonth() is zero-based
  const dd = this.getDate().toString()
  return yyyy + (mm[1] ? mm : '0' + mm[0]) + (dd[1] ? dd : '0' + dd[0]) // padding
}
Date.prototype.ddmmyyyy = function () {
  const yyyy = this.getFullYear().toString()
  const mm = (this.getMonth() + 1).toString() // getMonth() is zero-based
  const dd = this.getDate().toString()
  return (dd[1] ? dd : '0' + dd[0]) + '.' + (mm[1] ? mm : '0' + mm[0]) + '.' + yyyy // padding
}
global.Base64 = {
  encode (str) {
    return Buffer.from(str).toString('base64')
  }
}
const dates = {
  convert (d) {
    return (
      d.constructor === Date
        ? d
        : d.constructor === Array
          ? new Date(d[0], d[1], d[2])
          : d.constructor === Number
            ? new Date(d)
            : d.constructor === String
              ? new Date(d)
              : typeof d === 'object'
                ? new Date(d.year, d.month, d.date)
                : NaN
    )
  },
  compare (a, b) {
    return (
      isFinite(a = this.convert(a).valueOf()) &&
        isFinite(b = this.convert(b).valueOf())
        ? (a > b) - (a < b)
        : NaN
    )
  },
  inRange (d, start, end) {
    return (
      isFinite(d = this.convert(d).valueOf()) &&
        isFinite(start = this.convert(start).valueOf()) &&
        isFinite(end = this.convert(end).valueOf())
        ? start <= d && d <= end
        : NaN
    )
  }
}

String.prototype.splitKeep = function (splitter, ahead) {
  const self = this
  const result = []
  if (splitter != '') {
    function getSubst (value) {
      const substChar = value[0] == '0' ? '1' : '0'
      let subst = ''
      for (let i = 0; i < value.length; i++) {
        subst += substChar
      }
      return subst
    };
    const matches = []
    const replaceName = splitter instanceof RegExp ? 'replace' : 'replaceAll'
    const r = self[replaceName](splitter, function (m, i, e) {
      matches.push({ value: m, index: i })
      return getSubst(m)
    })
    let lastIndex = 0
    for (let i = 0; i < matches.length; i++) {
      const m = matches[i]
      const nextIndex = ahead == true ? m.index : m.index + m.value.length
      if (nextIndex != lastIndex) {
        var part = self.substring(lastIndex, nextIndex)
        result.push(part)
        lastIndex = nextIndex
      }
    };
    if (lastIndex < self.length) {
      var part = self.substring(lastIndex, self.length)
      result.push(part)
    };
  } else {
    result.add(self)
  };
  return result
}

var EIMZOClient = {
  NEW_API: false,
  checkVersion (success, fail) {
    CAPIWS.version(function (event, data) {
      if (data.success === true) {
        if (data.major && data.minor) {
          const installedVersion = parseInt(data.major) * 100 + parseInt(data.minor)
          EIMZOClient.NEW_API = installedVersion >= 336
          success(data.major, data.minor)
        } else {
          fail(null, 'E-IMZO Version is undefined')
        }
      } else {
        fail(null, data.reason)
      }
    }, function (e) {
      fail(e, null)
    })
  },
  installApiKeys (success, fail) {
    CAPIWS.apikey(EIMZOClient.API_KEYS, function (event, data) {
      if (data.success) {
        success()
      } else {
        fail(null, data.reason)
      }
    }, function (e) {
      fail(e, null)
    })
  },
  listAllUserKeys (itemIdGen, itemUiGen, success, fail) {
    const items = []
    const errors = []
    if (!EIMZOClient.NEW_API) {
      EIMZOClient._findCertKeys(itemIdGen, itemUiGen, items, errors, function (firstItmId) {
        EIMZOClient._findPfxs(itemIdGen, itemUiGen, items, errors, function (firstItmId2) {
          if (items.length === 0 && errors.length > 0) {
            fail(errors[0].e, errors[0].r)
          } else {
            let firstId = null
            if (items.length === 1) {
              if (firstItmId) {
                firstId = firstItmId
              } else if (firstItmId2) {
                firstId = firstItmId2
              }
            }
            success(items, firstId)
          }
        })
      })
    } else {
      EIMZOClient._findCertKeys2(itemIdGen, itemUiGen, items, errors, function (firstItmId) {
        EIMZOClient._findPfxs2(itemIdGen, itemUiGen, items, errors, function (firstItmId2) {
          EIMZOClient._findTokens2(itemIdGen, itemUiGen, items, errors, function (firstItmId3) {
            if (items.length === 0 && errors.length > 0) {
              fail(errors[0].e, errors[0].r)
            } else {
              let firstId = null
              if (items.length === 1) {
                if (firstItmId) {
                  firstId = firstItmId
                } else if (firstItmId2) {
                  firstId = firstItmId2
                } else if (firstItmId3) {
                  firstId = firstItmId3
                }
              }
              success(items, firstId)
            }
          })
        })
      })
    }
  },
  loadKey (itemObject, success, fail, verifyPassword) {
    if (itemObject) {
      const vo = itemObject
      if (vo.type === 'certkey') {
        CAPIWS.callFunction({ plugin: 'certkey', name: 'load_key', arguments: [vo.disk, vo.path, vo.name, vo.serialNumber] }, function (event, data) {
          if (data.success) {
            const id = data.keyId
            success(id)
          } else {
            fail(null, data.reason)
          }
        }, function (e) {
          fail(e, null)
        })
      } else if (vo.type === 'pfx') {
        CAPIWS.callFunction({ plugin: 'pfx', name: 'load_key', arguments: [vo.disk, vo.path, vo.name, vo.alias] }, function (event, data) {
          if (data.success) {
            const id = data.keyId
            if (verifyPassword) {
              CAPIWS.callFunction({ name: 'verify_password', plugin: 'pfx', arguments: [id] }, function (event, data) {
                if (data.success) {
                  success(id)
                } else {
                  fail(null, data.reason)
                }
              }, function (e) {
                fail(e, null)
              })
            } else {
              success(id)
            }
          } else {
            fail(null, data.reason)
          }
        }, function (e) {
          fail(e, null)
        })
      } else if (vo.type === 'ftjc') {
        CAPIWS.callFunction({ plugin: 'ftjc', name: 'load_key', arguments: [vo.cardUID] }, function (event, data) {
          if (data.success) {
            const id = data.keyId
            if (verifyPassword) {
              CAPIWS.callFunction({ plugin: 'ftjc', name: 'verify_pin', arguments: [id, '1'] }, function (event, data) {
                if (data.success) {
                  success(id)
                } else {
                  fail(null, data.reason)
                }
              }, function (e) {
                fail(e, null)
              })
            } else {
              success(id)
            }
          } else {
            fail(null, data.reason)
          }
        }, function (e) {
          fail(e, null)
        })
      }
    }
  },
  changeKeyPassword (itemObject, success, fail) {
    if (itemObject) {
      const vo = itemObject
      if (vo.type === 'pfx') {
        CAPIWS.callFunction({ plugin: 'pfx', name: 'load_key', arguments: [vo.disk, vo.path, vo.name, vo.alias] }, function (event, data) {
          if (data.success) {
            const id = data.keyId
            CAPIWS.callFunction({ name: 'change_password', plugin: 'pfx', arguments: [id] }, function (event, data) {
              if (data.success) {
                success()
              } else {
                fail(null, data.reason)
              }
            }, function (e) {
              fail(e, null)
            })
          } else {
            fail(null, data.reason)
          }
        }, function (e) {
          fail(e, null)
        })
      } else if (vo.type === 'ftjc') {
        CAPIWS.callFunction({ plugin: 'ftjc', name: 'load_key', arguments: [vo.cardUID] }, function (event, data) {
          if (data.success) {
            const id = data.keyId
            CAPIWS.callFunction({ name: 'change_pin', plugin: 'ftjc', arguments: [id, '1'] }, function (event, data) {
              if (data.success) {
                success()
              } else {
                fail(null, data.reason)
              }
            }, function (e) {
              fail(e, null)
            })
          } else {
            fail(null, data.reason)
          }
        }, function (e) {
          fail(e, null)
        })
      }
    }
  },
  createPkcs7: function (id, data, timestamper, success, fail) {
    CAPIWS.callFunction({ plugin: "pkcs7", name: "create_pkcs7", arguments: [Base64.encode(data), id, 'no'] }, function (event, data) {
        if (data.success) {
            var pkcs7 = data.pkcs7_64;
            if (timestamper) {
                var sn = data.signer_serial_number;
                timestamper(data.signature_hex, function (tst) {
                    CAPIWS.callFunction({ plugin: "pkcs7", name: "attach_timestamp_token_pkcs7", arguments: [pkcs7, sn, tst] }, function (event, data) {
                        if (data.success) {
                            var pkcs7tst = data.pkcs7_64;
                            success(pkcs7tst);
                        } else {
                            fail(null, data.reason);
                        }
                    }, function (e) {
                        fail(e, null);
                    });
                }, fail);
            } else {
                success(pkcs7);
            }
        } else {
            fail(null, data.reason);
        }
    }, function (e) {
        fail(e, null);
    });
},
appendPkcs7Attached: function (id, data, timestamper, success, fail) {
  CAPIWS.callFunction({ plugin: "pkcs7", name: "append_pkcs7_attached", arguments: [data, id] }, function (event, data) {
      if (data.success) {
          var pkcs7 = data.pkcs7_64;
          if (timestamper) {
              var sn = data.signer_serial_number;
              timestamper(data.signature_hex, function (tst) {
                  CAPIWS.callFunction({ plugin: "pkcs7", name: "attach_timestamp_token_pkcs7", arguments: [pkcs7, sn, tst] }, function (event, data) {
                      if (data.success) {
                          var pkcs7tst = data.pkcs7_64;
                          success(pkcs7tst);
                      } else {
                          fail(null, data.reason);
                      }
                  }, function (e) {
                      fail(e, null);
                  });
              }, fail);
          } else {
              success(pkcs7);
          }
      } else {
          fail(null, data.reason);
      }
  }, function (e) {
      fail(e, null);
  });
},
  _getX500Val (s, f) {
    const res = s.splitKeep(/,[A-Z]+=/g, true)
    for (const i in res) {
      const n = res[i].search((i > 0 ? ',' : '') + f + '=')
      if (n !== -1) {
        return res[i].slice(n + f.length + 1 + (i > 0 ? 1 : 0))
      }
    }
    return ''
  },
  _findCertKeyCertificates (itemIdGen, itemUiGen, items, errors, allDisks, diskIndex, params, callback) {
    if (parseInt(diskIndex) + 1 > allDisks.length) {
      callback(params)
      return
    }
    CAPIWS.callFunction({ plugin: 'certkey', name: 'list_certificates', arguments: [allDisks[diskIndex]] }, function (event, data) {
      if (data.success) {
        for (const rec in data.certificates) {
          const el = data.certificates[rec]
          const vo = {
            disk: el.disk,
            path: el.path,
            name: el.name,
            serialNumber: el.serialNumber,
            subjectName: el.subjectName,
            validFrom: new Date(el.validFrom),
            validTo: new Date(el.validTo),
            issuerName: el.issuerName,
            publicKeyAlgName: el.publicKeyAlgName,
            CN: EIMZOClient._getX500Val(el.subjectName, 'CN'),
            TIN: EIMZOClient._getX500Val(el.subjectName, 'INITIALS'),
            O: EIMZOClient._getX500Val(el.subjectName, 'O'),
            T: EIMZOClient._getX500Val(el.subjectName, 'T'),
            type: 'certkey'
          }
          // if (!vo.TIN) { continue }
          const itmkey = itemIdGen(vo, rec)
          if (params.length === 0) {
            params.push(itmkey)
          }
          const itm = itemUiGen(itmkey, vo)
          items.push(itm)
        }
      } else {
        errors.push({ r: data.reason })
      }
      EIMZOClient._findCertKeyCertificates(itemIdGen, itemUiGen, items, errors, allDisks, parseInt(diskIndex) + 1, params, callback)
    }, function (e) {
      errors.push({ e })
      EIMZOClient._findCertKeyCertificates(itemIdGen, itemUiGen, items, errors, allDisks, parseInt(diskIndex) + 1, params, callback)
    })
  },
  _findCertKeys (itemIdGen, itemUiGen, items, errors, callback) {
    const allDisks = []
    CAPIWS.callFunction({ plugin: 'certkey', name: 'list_disks' }, function (event, data) {
      if (data.success) {
        for (const rec in data.disks) {
          allDisks.push(data.disks[rec])
          if (parseInt(rec) + 1 >= data.disks.length) {
            const params = []
            EIMZOClient._findCertKeyCertificates(itemIdGen, itemUiGen, items, errors, allDisks, 0, params, function (params) {
              callback(params[0])
            })
          }
        }
      } else {
        errors.push({ r: data.reason })
      }
    }, function (e) {
      errors.push({ e })
      callback()
    })
  },
  _findPfxCertificates (itemIdGen, itemUiGen, items, errors, allDisks, diskIndex, params, callback) {
    if (parseInt(diskIndex) + 1 > allDisks.length) {
      callback(params)
      return
    }
    CAPIWS.callFunction({ plugin: 'pfx', name: 'list_certificates', arguments: [allDisks[diskIndex]] }, function (event, data) {
      if (data.success) {
        for (const rec in data.certificates) {
          const el = data.certificates[rec]
          let x500name_ex = el.alias.toUpperCase()
          x500name_ex = x500name_ex.replace('1.2.860.3.16.1.1=', 'INN=')
          x500name_ex = x500name_ex.replace('1.2.860.3.16.1.2=', 'PINFL=')
          const vo = {
            disk: el.disk,
            path: el.path,
            name: el.name,
            alias: el.alias,
            serialNumber: EIMZOClient._getX500Val(x500name_ex, 'SERIALNUMBER'),
            validFrom: new Date(EIMZOClient._getX500Val(x500name_ex, 'VALIDFROM').replace(/\./g, '-').replace(' ', 'T')),
            validTo: new Date(EIMZOClient._getX500Val(x500name_ex, 'VALIDTO').replace(/\./g, '-').replace(' ', 'T')),
            CN: EIMZOClient._getX500Val(x500name_ex, 'CN'),
            TIN: (EIMZOClient._getX500Val(x500name_ex, 'INN') ? EIMZOClient._getX500Val(x500name_ex, 'INN') : EIMZOClient._getX500Val(x500name_ex, 'UID')),
            UID: EIMZOClient._getX500Val(x500name_ex, 'UID'),
            O: EIMZOClient._getX500Val(x500name_ex, 'O'),
            T: EIMZOClient._getX500Val(x500name_ex, 'T'),
            type: 'pfx'
          }
          // if (!vo.TIN) { continue }
          const itmkey = itemIdGen(vo, rec)
          if (params.length === 0) {
            params.push(itmkey)
          }
          const itm = itemUiGen(itmkey, vo)
          items.push(itm)
        }
      } else {
        errors.push({ r: data.reason })
      }
      EIMZOClient._findPfxCertificates(itemIdGen, itemUiGen, items, errors, allDisks, parseInt(diskIndex) + 1, params, callback)
    }, function (e) {
      errors.push({ e })
      EIMZOClient._findPfxCertificates(itemIdGen, itemUiGen, items, errors, allDisks, parseInt(diskIndex) + 1, params, callback)
    })
  },
  _findPfxs (itemIdGen, itemUiGen, items, errors, callback) {
    const allDisks = []
    CAPIWS.callFunction({ plugin: 'pfx', name: 'list_disks' }, function (event, data) {
      if (data.success) {
        const disks = data.disks
        for (const rec in disks) {
          allDisks.push(data.disks[rec])
          if (parseInt(rec) + 1 >= data.disks.length) {
            const params = []
            EIMZOClient._findPfxCertificates(itemIdGen, itemUiGen, items, errors, allDisks, 0, params, function (params) {
              callback(params[0])
            })
          }
        }
      } else {
        errors.push({ r: data.reason })
      }
    }, function (e) {
      errors.push({ e })
      callback()
    })
  },
  _findCertKeys2 (itemIdGen, itemUiGen, items, errors, callback) {
    let itmkey0
    CAPIWS.callFunction({ plugin: 'certkey', name: 'list_all_certificates' }, function (event, data) {
      if (data.success) {
        for (const rec in data.certificates) {
          const el = data.certificates[rec]
          const vo = {
            disk: el.disk,
            path: el.path,
            name: el.name,
            serialNumber: el.serialNumber,
            subjectName: el.subjectName,
            validFrom: new Date(el.validFrom),
            validTo: new Date(el.validTo),
            issuerName: el.issuerName,
            publicKeyAlgName: el.publicKeyAlgName,
            CN: EIMZOClient._getX500Val(el.subjectName, 'CN'),
            TIN: EIMZOClient._getX500Val(el.subjectName, 'INITIALS'),
            O: EIMZOClient._getX500Val(el.subjectName, 'O'),
            T: EIMZOClient._getX500Val(el.subjectName, 'T'),
            type: 'certkey'
          }
          // if (!vo.TIN) { continue }
          const itmkey = itemIdGen(vo, rec)
          if (!itmkey0) {
            itmkey0 = itmkey
          }
          const itm = itemUiGen(itmkey, vo)
          items.push(itm)
        }
      } else {
        errors.push({ r: data.reason })
      }
      callback(itmkey0)
    }, function (e) {
      errors.push({ e })
      callback(itmkey0)
    })
  },
  _findPfxs2 (itemIdGen, itemUiGen, items, errors, callback) {
    let itmkey0
    CAPIWS.callFunction({ plugin: 'pfx', name: 'list_all_certificates' }, function (event, data) {
      if (data.success) {
        for (const rec in data.certificates) {
          const el = data.certificates[rec]
          let x500name_ex = el.alias.toUpperCase()
          x500name_ex = x500name_ex.replace('1.2.860.3.16.1.1=', 'INN=')
          x500name_ex = x500name_ex.replace('1.2.860.3.16.1.2=', 'PINFL=')
          // console.log(2222222, x500name_ex, el, EIMZOClient._getX500Val(x500name_ex, 'PINFL'))
          const vo = {
            disk: el.disk,
            path: el.path,
            name: el.name,
            alias: el.alias,
            serialNumber: EIMZOClient._getX500Val(x500name_ex, 'SERIALNUMBER'),
            validFrom: new Date(EIMZOClient._getX500Val(x500name_ex, 'VALIDFROM').replace(/\./g, '-').replace(' ', 'T')),
            validTo: new Date(EIMZOClient._getX500Val(x500name_ex, 'VALIDTO').replace(/\./g, '-').replace(' ', 'T')),
            isCompany: !!EIMZOClient._getX500Val(x500name_ex, 'INN'),
            CN: EIMZOClient._getX500Val(x500name_ex, 'CN'),
            TIN: (EIMZOClient._getX500Val(x500name_ex, 'INN') ? EIMZOClient._getX500Val(x500name_ex, 'INN') : EIMZOClient._getX500Val(x500name_ex, 'UID')),
            UID: EIMZOClient._getX500Val(x500name_ex, 'UID'),
            PINFL: EIMZOClient._getX500Val(x500name_ex, 'PINFL'),
            O: EIMZOClient._getX500Val(x500name_ex, 'O'),
            T: EIMZOClient._getX500Val(x500name_ex, 'T'),
            type: 'pfx'
          }
          // if (!vo.TIN) { continue }
          const itmkey = itemIdGen(vo, rec)
          if (!itmkey0) {
            itmkey0 = itmkey
          }
          const itm = itemUiGen(itmkey, vo)
          items.push(itm)
        }
      } else {
        errors.push({ r: data.reason })
      }
      callback(itmkey0)
    }, function (e) {
      errors.push({ e })
      callback(itmkey0)
    })
  },
  _findTokens2 (itemIdGen, itemUiGen, items, errors, callback) {
    let itmkey0
    CAPIWS.callFunction({ plugin: 'ftjc', name: 'list_all_keys', arguments: [''] }, function (event, data) {
      if (data.success) {
        for (const rec in data.tokens) {
          const el = data.tokens[rec]
          let x500name_ex = el.info.toUpperCase()
          x500name_ex = x500name_ex.replace('1.2.860.3.16.1.1=', 'INN=')
          x500name_ex = x500name_ex.replace('1.2.860.3.16.1.2=', 'PINFL=')
          const vo = {
            cardUID: el.cardUID,
            statusInfo: el.statusInfo,
            ownerName: el.ownerName,
            info: el.info,
            serialNumber: EIMZOClient._getX500Val(x500name_ex, 'SERIALNUMBER'),
            validFrom: new Date(EIMZOClient._getX500Val(x500name_ex, 'VALIDFROM')),
            validTo: new Date(EIMZOClient._getX500Val(x500name_ex, 'VALIDTO')),
            CN: EIMZOClient._getX500Val(x500name_ex, 'CN'),
            TIN: (EIMZOClient._getX500Val(x500name_ex, 'INN') ? EIMZOClient._getX500Val(x500name_ex, 'INN') : EIMZOClient._getX500Val(x500name_ex, 'UID')),
            UID: EIMZOClient._getX500Val(x500name_ex, 'UID'),
            O: EIMZOClient._getX500Val(x500name_ex, 'O'),
            T: EIMZOClient._getX500Val(x500name_ex, 'T'),
            type: 'ftjc'
          }
          // if (!vo.TIN) { continue }
          const itmkey = itemIdGen(vo, rec)
          if (!itmkey0) {
            itmkey0 = itmkey
          }
          const itm = itemUiGen(itmkey, vo)
          items.push(itm)
        }
      } else {
        errors.push({ r: data.reason })
      }
      callback(itmkey0)
    }, function (e) {
      errors.push({ e })
      callback(itmkey0)
    })
  }
}
export default EIMZOClient
